"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBodyForParameters = exports.getContentType = exports.getFromInsensitiveKey = void 0;
exports.getFromInsensitiveKey = (obj, caseInsensitiveKey) => {
    if (!obj || !caseInsensitiveKey) {
        return null;
    }
    for (let key of Object.keys(obj)) {
        if (key.toLowerCase() == caseInsensitiveKey.toLowerCase()) {
            return obj[key];
        }
    }
    return null;
};
exports.getContentType = (request) => {
    let contentType = exports.getFromInsensitiveKey(request.headers, "Content-Type");
    if (!contentType) {
        return null;
    }
    return contentType.toLowerCase();
};
const EQUALS = "=";
const AMP = "&";
exports.parseBodyForParameters = (body) => {
    if (!body) {
        return null;
    }
    let parts = body.split(AMP);
    let params = {};
    for (let part of parts) {
        let keyValue = part.trim().split(EQUALS);
        let key = keyValue[0];
        let value = keyValue[1]
            .replace(/^"(.*)"$/, '$1'); // trim the first and last double quote
        params[key] = decodeURIComponent(value);
    }
    return params;
};
//# sourceMappingURL=request-utils.js.map